export default "__VITE_ASSET__B6QXbi6D__"